import { FC } from "react";
import useDetailTracking, { Props, ReceivedProps } from "./hook";
import { Styles } from "./styled";

import StylesMain from "../components/StyleMain";
import HeaderTitle from "../components/HeaderTitle";
import WeekChoose from "./WeekChoose";
import Timeline from "../components/Timeline";
import Summary from "./Summary";
import dayjs from "dayjs";
import { Form } from "antd";
import { HiArrowUturnLeft } from "react-icons/hi2";
import { RiArrowGoBackFill } from "react-icons/ri";
import { isMobile, isTablet } from "react-device-detect";
import Button from "@lhd/components/Button";

const DetailTrackingLayout: FC<Props> = (props) => {
  const isMobileOrTablet = isMobile || isTablet;
  const {
    isEditMode,
    currentDate,
    handleOnChangeDate,
    data,
    form,
    handleSubmit,
    isPageLoading,
    isSaving,
    hasFormChanges,
    handleBackToList,
    exitEditMode,
    canEditAllAttendanceFields,
    summaryServerNowMs,
    liveSummaryLogtimes,
    isLiveSessionOpen,
    summaryClosedAtMs,
  } = props;

  return (
    <StylesMain compactShell isLoading={isPageLoading || isSaving}>
      <Styles
        className={`detail-tracking${isEditMode ? " is-editing" : ""}${
          !isMobileOrTablet ? " detail-tracking--light" : ""
        }`}
      >
        <header
          className={`detail-header-bar${
            !isMobileOrTablet ? " detail-header-bar--manager" : ""
          }`}
        >
          {!isMobileOrTablet ? (
            <>
              <div className="detail-header-left">
                <p className="detail-header-date">
                  {dayjs(currentDate).format("YYYY/M/D")}
                </p>
                {isMobileOrTablet && (
                  <p className="detail-header-caption">今日のタイムライン</p>
                )}
              </div>
              {!isEditMode && (
                <div className="detail-header-actions">
                  <Button
                    icon={<RiArrowGoBackFill size={16} />}
                    className="btn-back"
                    label="戻る"
                    onClick={handleBackToList}
                  />
                </div>
              )}
            </>
          ) : (
            <>
              <div className="detail-header-center">
                <HeaderTitle
                  title="今日のタイムライン"
                  subTitle={dayjs(currentDate).format("YYYY/M/D")}
                />
              </div>
              {!isEditMode && (
                <div className="detail-header-actions">
                  <button
                    type="button"
                    className="button-header-back"
                    onClick={handleBackToList}
                  >
                    <HiArrowUturnLeft size={20} />
                    <span>戻る</span>
                  </button>
                </div>
              )}
            </>
          )}
        </header>

        <WeekChoose
          dateDefaultActive={currentDate}
          onChange={handleOnChangeDate}
          className="mb-24px week-choose-block"
        />

        <div className="container-time_line-summary">
          <Form
            className="detail-timeline-form"
            disabled={!isEditMode}
            form={form}
            onFinish={handleSubmit}
          >
            {data && (
              <Timeline
                className={
                  !isMobileOrTablet ? "detail-timeline-block" : "mb-24px"
                }
                data={data}
                editable={isEditMode}
                canEditAllFields={canEditAllAttendanceFields}
              />
            )}
          </Form>
          <Summary
            className={
              !isMobileOrTablet
                ? "detail-summary-section detail-summary-column"
                : "detail-summary-section mb-2"
            }
            data={data}
            liveLogtimes={liveSummaryLogtimes}
            serverNowMs={summaryServerNowMs}
            isLiveSessionOpen={isLiveSessionOpen}
            closedAtMs={summaryClosedAtMs}
          />
        </div>

        <div
          className={`container-footer${isEditMode ? " show" : ""}${
            !isMobileOrTablet ? " container-footer--manager" : ""
          }`}
        >
          <button
            type="button"
            className="button-primary footer-btn-primary"
            disabled={isSaving || !hasFormChanges}
            onClick={() => form.submit()}
          >
            <span>保存</span>
          </button>
          <button
            type="button"
            className="button-outline footer-btn-cancel"
            disabled={isSaving}
            onClick={exitEditMode}
          >
            <span>キャンセル</span>
          </button>
        </div>
      </Styles>
    </StylesMain>
  );
};

const DetailTracking: FC<ReceivedProps> = (props) => (
  <DetailTrackingLayout {...useDetailTracking(props)} />
);

export default DetailTracking;
